import { render, staticRenderFns } from "./LazyPointsTree.vue?vue&type=template&id=6b023431&scoped=true"
import script from "./LazyPointsTree.vue?vue&type=script&lang=js"
export * from "./LazyPointsTree.vue?vue&type=script&lang=js"
import style0 from "./LazyPointsTree.vue?vue&type=style&index=0&id=6b023431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b023431",
  null
  
)

export default component.exports